module.exports = __webpack_public_path__ + "static/media/5.9e1252c7.jpg";